import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { RubyLoader } from './RubyLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, getAccessToken } = useAuth();
  const location = useLocation();
  const [tokenReady, setTokenReady] = useState(false);

  // Store auth token in localStorage for apiService.ts
  useEffect(() => {
    if (isAuthenticated) {
      console.log('[ProtectedRoute] Getting access token...');
      getAccessToken().then((token) => {
        console.log('[ProtectedRoute] Token received:', !!token, token ? `(${token.substring(0, 20)}...)` : '(null)');
        if (token) {
          localStorage.setItem('jwtToken', token);
          console.log('[ProtectedRoute] Token stored in localStorage');
        }
        setTokenReady(true);
      });
    } else {
      console.log('[ProtectedRoute] Not authenticated, clearing token');
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('refreshToken');
      setTokenReady(false);
    }
  }, [isAuthenticated, getAccessToken]);

  if (isLoading || (isAuthenticated && !tokenReady)) {
    return (
      <RubyLoader variant="screen" className="bg-dark-900" />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
